import { View, Image } from "@react-pdf/renderer";
import logo from "../images/logo.png";
import euroventCertified from "../images/euroventCertified.jpg";

const TechCardHeader = ({ styles }) => {
  return (
    <View fixed style={styles.section}>
      <View style={styles.about}>
        <View style={{ ...styles["left-logo"] }}>
          <Image src={logo} alt="logo" style={{ width: "90%" }} />
        </View>
        <View style={{ ...styles["right-logo"] }}>
          <Image src={euroventCertified} alt="logo" style={{ width: "50%" }} />
        </View>
      </View>
    </View>
  );
};

export default TechCardHeader;
